<template>
    <div class="card-detail">
      <!-- 标题栏 -->
      <div class="header">
        <button class="back-button" @click="goBack">
          <img src="@/assets/arrow-left-s-line.png" alt="返回" class="back-icon" />
        </button>
        <h1>兑换礼品券: {{ cardName }}</h1>
      </div>
  
      <!-- 产品组合列表 -->
      <div class="product-list">
        <div
          v-for="(product, index) in products"
          :key="index"
          class="product-item"
          :class="{ selected: selectedProduct === product.productId }"
          @click="selectProduct(product.productId)"
        >
          <!-- 单选按钮 -->
          <div class="radio-button">
            <input
              type="radio"
              :id="'product-' + product.productId"
              :value="product.productId"
              v-model="selectedProduct"
            />
            <label :for="'product-' + product.productId"></label>
          </div>
  
          <img :src="product.mainPic" :alt="product.productName" class="product-image" />
  
          <div class="product-info" @click="goToProductDetail(product)">
            <p class="product-name"><span class="label">套餐:</span> {{ product.productName }}</p>
            <!-- <p class="product-desc"><span class="label">产品:</span> {{ product.productDesc }}</p>
            <div class="product-meta">
              <p class="product-price"><span class="label">价格:</span> ¥{{ product.productPrice }}</p>
              <p class="product-stock"><span class="label">库存:</span> {{ product.quantityLeft }}</p>
            </div> -->
          </div>
        </div>
  
        <!-- 预留底部空白空间 -->
        <div class="spacer"></div>
      </div>
  
      <!-- 底部固定区域 -->
      <div class="footer">
        <button class="exchange-button" @click="handleExchange">立即兑换</button>
      </div>
    </div>
  </template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import axios from 'axios';

@Options({})
export default class CardDetailView extends Vue {
  cardName = ''; // 卡片名称
  cardTypeId = '';
  selectedProduct: string | null = null; // 当前选中的产品 ID
  products: Product[] = [];

  apiUrl = process.env.VUE_APP_API_BASE_URL;

  async created() {
    // 从路由 query 中获取 cardName
    this.cardTypeId = this.$route.query.cardTypeId as string;
    this.cardName = this.$route.query.cardName as string;

    // 获取产品列表数据
    await this.fetchProducts();
  }

  // 获取产品列表数据
  async fetchProducts() {
    try {
      const response = await axios.post(this.apiUrl + '/product/query/list', {
        cardTypeId: this.cardTypeId, // 请求体参数
      });

      if (response.data.code === 0 && response.data.data) {
        this.products = response.data.data.data; // 将产品列表数据赋值给 products
      } else {
        console.error('API 返回数据异常:', response.data.msg);
      }
    } catch (error) {
      console.error('Failed to fetch products:', error);
    }
  }

  // 返回上一页
  goBack() {
    this.$router.go(-1);
  }

  // 选择产品
  selectProduct(productId: string) {
    this.selectedProduct = productId;
  }

  // 跳转到产品详情页面
  goToProductDetail(product: Product) {
    this.$router.push({
      path: '/product-detail',
      query: { product: JSON.stringify(product) }, // 传递 product 对象
    });
  }

  // 处理兑换逻辑
handleExchange() {
  if (!this.selectedProduct) {
    alert('请先勾选一个产品！'); // 提示用户选择产品
    return;
  }

  // 获取选中的产品
  const selectedProduct = this.products.find(
    (product) => product.productId === this.selectedProduct
  );

  if (!selectedProduct) {
    alert('未找到选中的产品！');
    return;
  }

  // 跳转到兑换页面，并传入 cardTypeId、productId 和 productName
  this.$router.push({
    path: '/exchange', // 兑换页面的路径
    query: {
      cardTypeId: this.cardTypeId, // 传递 cardTypeId
      productId: this.selectedProduct, // 传递选中的 productId
      productName: selectedProduct.productName, // 传递选中的 productName
    },
  });
}
}

// 定义产品数据结构
interface Product {
  cardTypeId: string;
  detailPicFive: string;
  detailPicFour: string;
  detailPicOne: string;
  detailPicSix: string;
  detailPicThree: string;
  detailPicTwo: string;
  isValid: boolean;
  mainPic: string;
  productDesc: string;
  productId: string;
  productName: string;
  productPrice: number;
  quantityLeft: number;
  quantityTotal: number;
}
</script>

<style scoped>
.card-detail {
  display: flex;
  flex-direction: column;
  height: 100vh; /* 页面高度为视窗高度 */
  background: linear-gradient(to bottom, #ff3b3b, #ff7e7e);
}

.header {
  display: flex;
  align-items: center;
  padding: 16px;
  background-color: transparent; /* 移除背景色 */
  position: relative;
  text-align: center; /* 标题居中 */
}

.back-button {
  background: none;
  border: none;
  font-size: 24px; /* 增大箭头大小 */
  color: white; /* 箭头颜色为白色 */
  cursor: pointer;
  position: absolute; /* 绝对定位 */
  left: 16px; /* 距离左侧 16px */
}

.back-icon {
  width: 36px; /* 图标宽度 */
  height: 36px; /* 图标高度 */
}

.header h1 {
  font-size: 24px;
  color: white; /* 标题颜色为白色 */
  margin: 0 auto; /* 标题居中 */
}

.product-list {
  flex: 1; /* 占据剩余空间 */
  padding: 16px;
  overflow-y: auto; /* 允许滚动 */
}

.product-info {
  flex: 1;
  text-align: left; /* 文本左对齐 */
}

.product-name,
.product-desc,
.product-price,
.product-stock {
  font-size: 16px;
  color: #333;
  margin: 0 0 8px 0;
}

.label {
  font-weight: bold; /* 冒号左侧文本加粗 */
}

.product-meta {
  display: flex;
  align-items: center;
  gap: 16px; /* 价格和库存之间的间距 */
}

.product-item {
  display: flex;
  align-items: center;
  padding: 16px;
  margin-bottom: 16px;
  background-color: #ffffff; /* 产品项背景色 */
  border-radius: 8px; /* 圆角 */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1); /* 阴影 */
  cursor: pointer;
  transition: background-color 0.3s;
}

.product-item.selected {
  background-color: #ffe0cc; /* 选中状态背景色 */
}

.product-image {
  width: 60px;
  height: 60px;
  border-radius: 8px; /* 圆角 */
  margin-right: 16px;
}

.product-item p {
  font-size: 16px;
  color: #333;
  margin: 0;
}

/* 预留底部空白空间 */
.spacer {
  height: 80px; /* 与 footer 高度一致 */
}

/* 底部固定区域 */
.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 16px;
  background-color: transparent; /* 移除 footer 的白色背景 */
  text-align: center;
}

.exchange-button {
  width: 100%;
  padding: 12px;
  background-color: white; /* 按钮背景色改为白色 */
  color: #ff7e7e; /* 按钮文字颜色改为橙色 */
  border: none;
  border-radius: 8px; /* 圆角 */
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;
}

.exchange-button:hover {
  background-color: #f0f0f0; /* 悬停时背景色变浅灰色 */
}

.exchange-button:disabled {
  background-color: #cccccc; /* 禁用状态背景色 */
  color: #999999; /* 禁用状态文字颜色 */
  cursor: not-allowed;
}

.radio-button {
  margin-right: 16px; /* 单选按钮与图片之间的间距 */
}

.radio-button input[type="radio"] {
  display: none; /* 隐藏原生单选按钮 */
}

.radio-button label {
  display: inline-block;
  width: 20px; /* 单选按钮大小 */
  height: 20px;
  border: 2px solid #ff7e7e; /* 边框颜色改为橙色 */
  border-radius: 50%; /* 圆形 */
  cursor: pointer;
  position: relative;
}

.radio-button input[type="radio"]:checked + label::after {
  content: '';
  display: block;
  width: 12px; /* 选中状态的内圆大小 */
  height: 12px;
  background-color: #ff7e7e; /* 选中状态的内圆颜色改为橙色 */
  border-radius: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>